export const restructureArray = (array: any, length: number) => {
 let size = 0,
  subArray: any = []
 const parentArray = []
 array?.forEach((each: any) => {
  subArray.push(each)
  size++
  if (size === length) {
   parentArray.push(subArray)
   size = 0
   subArray = []
  }
 })
 subArray.length && parentArray.push(subArray)
 return parentArray
}



  
